module.exports = __webpack_public_path__ + "img/header.41ac21fa.png";